module.exports = __webpack_public_path__ + "img/1195_carbon.39e65c25.jpg";